module.exports = __webpack_public_path__ + "img/IMG_1401_L_BlackMatted_MockedUp.e3788c12.jpg";